export const useAlert = ({ onActionClick }) => {
  const handleActionClick = (e) => {
    if (onActionClick) {
      onActionClick(e);
    }
  };

  return {
    handleActionClick,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Alert/hooks/useAlert.js